import { coalesceMeetingIntelligence } from 'shared/utils/meeting_intelligence'

const PARTICIPANT_ROLE_TO_ATTENDEE_KIND: Record<string, string> = {
  HOST: 'HOST',
  COHOST: 'COHOST',
  ATTENDEE: 'INVITEE',
}

/** cmd `CMDMeeting.participants` → the `attendees` shape `mapNodeToMeeting` expects. */
const mapParticipantsToAttendees = (participants: any): any[] => {
  if (!Array.isArray(participants)) return []
  return participants.map((participant: any) => ({
    kind: PARTICIPANT_ROLE_TO_ATTENDEE_KIND[participant?.role] ?? 'INVITEE',
    name: participant?.name,
    email: participant?.email,
    uuid: participant?.identifier,
    cancelled: participant?.status === 'DECLINED',
    noShow: Boolean(participant?.noShow),
    rescheduled: Boolean(participant?.rescheduled),
  }))
}

/**
 * `listMeetings` / `meetingsPageList` return the flat `Meetings_CMDMeeting` node
 * (`title`, `startTime`, `participants`, `eventType`, `recapStatus`). Normalize it to the
 * snake-cased / `attendees` / `meeting_intelligence` shape `mapNodeToMeeting` consumes. Already-rich
 * (`Meetings_Meeting`) nodes pass through unchanged via the `??` fallbacks.
 */
export const normalizeSupergraphMeetingNode = (node: any): any => {
  if (node == null || typeof node !== 'object') return node

  const attendees = Array.isArray(node.attendees) && node.attendees.length > 0
    ? node.attendees
    : mapParticipantsToAttendees(node.participants)

  return {
    ...node,
    name: node.name ?? node.title,
    start_time: node.start_time ?? node.startTime,
    end_time: node.end_time ?? node.endTime,
    owner_user_uuid: node.owner_user_uuid ?? node.ownerUuid,
    location_kind: node.location_kind ?? node.locationKind,
    event_type: node.event_type ?? node.eventType,
    meeting_intelligence: coalesceMeetingIntelligence(node.meeting_intelligence, node.recapStatus),
    invitees_count: node.invitees_count ?? node.inviteesCount,
    invitees_limit: node.invitees_limit ?? node.inviteesLimit,
    attendees,
  }
}
